import {html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../WebComponent'
import Navigation from '../Navigation/Navigation'
import BerechtigteListService from '../../services/BerechtigteListService'
import VNBService from './VNBService'
import VNBColumns from './VNBColumns'
import VNBDto from './VNBDto'
import '@isceco/widget-library2/basic-elements/Title/Title.js'
import '@isceco/widget-library2/basic-elements/List/List.js'
import '@isceco/widget-library2/basic-elements/Filter/FilterGroup.js'
import '@isceco/widget-library2/basic-elements/Filter/StringFilter.js'

export default class Verteilnetzbetreiber extends WebComponent {

  constructor() {
    super()
    this.vnbService = new VNBService()
  }

  get translationFile() {
    return './views/Verteilnetzbetreiber/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  reload() {
    Promise.resolve(
      this.vnbService.getBackendListUrl()
    ).then(url => {
      this.url = url
    }).catch(_ => {
      this.url = ''
    }).finally(() =>
      this.render()
    )
  }

  getTemplate() {
    return html`
      <isceco-title id="page-title" text="${this.i18n.translate('vnb.uebersicht.title')}">
        <isceco-button text="${this.i18n.translate('vnb.table.action.import')}"
                       icon="file import"
                       variant="primary" size="small"
                       @click="${() => navigate({to: Navigation.ROUTES.vnbImport.url, allow: true})}"
        ></isceco-button>
      </isceco-title>
      <isceco-filter-group>
        <isceco-string-filter key="name"
                              label="${this.i18n.translate('vnb.table.header.name')}"
        ></isceco-string-filter>
        <isceco-string-filter key="extId"
                              label="${this.i18n.translate('vnb.table.filter.extId')}"
        ></isceco-string-filter>
        <isceco-string-filter key="adresse"
                              label="${this.i18n.translate('vnb.table.header.adresse')}"
        ></isceco-string-filter>
        <isceco-string-filter key="ostralVerantwortlicher"
                              label="${this.i18n.translate('vnb.table.header.ostralVerantwortlicher')}"
        ></isceco-string-filter>
      </isceco-filter-group>
      <isceco-list url="${this.url}"
                   .listService="${BerechtigteListService}"
                   .i18n="${this.i18n}"
                   .dtoMapper="${this.toDTO}"
                   .columns="${VNBColumns.getColumns()}"
                   .rowurl="${this.toDetailUrl}"
                   sort="name" order="asc"
      ></isceco-list>
    `
  }

  toDTO = row => new VNBDto(row)
  toDetailUrl = row => constructURL({to: Navigation.ROUTES.vnbStammdaten.url, id: row.extId})

}
customElements.define('eko-frontend-verteilnetzbetreiber', Verteilnetzbetreiber)
